<template>
	<div class="popup" @click="onClick">
		<ScrollableDocument :scrollable="!isShowing">
			<transition name="slide-bottom">
				<div v-if="isShowing" class="popup-content">
					<Close v-if="closable" @close="emits('close')" />
					<slot></slot>
				</div>
			</transition>
		</ScrollableDocument>
	</div>
</template>

<script setup>
import { ref } from '@vue/reactivity'
import { inject, onBeforeUnmount, onMounted } from '@vue/runtime-core'

import ScrollableDocument from '@/components/ScrollableDocument'
import Close from '@/components/Close'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
	closable: {
		type: Boolean,
		default: false
	},
	closeOnClickOverlay: {
		type: Boolean,
		default: false
	},
	title: {
		type: String,
		default: 'Unknown'
	},
	path: {
		type: Object,
		default: () => []
	}
})

const emits = defineEmits(['close'])
const amplitude = inject('amplitude')

const isShowing = ref(false)
const show = () => {
	isShowing.value = true
	amplitude.logEvent('PopupView', {
		title: props.title,
		path: props.path
	})
}
const hide = () => (isShowing.value = false)

onMounted(show)
onBeforeUnmount(hide)

const onClick = (event) => {
	if (props.closeOnClickOverlay && !event.target.closest('.popup-content')) {
		emits('close')
	}
}
</script>

<style scoped lang="scss">
.popup {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999;
	background-color: rgba(0, 0, 0, 0.6);

	&-content {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 1;
		background-color: #fff;
		border-radius: 1.2rem 1.2rem 0 0;
		overflow: hidden;

		@media (min-width: 500px) and (min-height: 500px) {
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			border-radius: 1rem;
			bottom: auto;
			max-height: 100%;
		}
	}
}
</style>
